var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop",attrs:{"id":"kt_footer"}},[_c('div',{staticClass:"kt-container",class:{ 'kt-container--fluid': _vm.isFluid() }},[_c('div',{staticClass:"kt-footer__copyright"},[_vm._v(" 2021  © BIG CORE ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }